import { Button } from "PFComponents/button";
import { Checkbox } from "PFComponents/checkbox";
import { Inline } from "PFComponents/containers";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useActivityFormStore } from "../../../activity_form_store";
import { useActivityFormSubmit } from "../../../hooks/use_activity_form_submit";
import css from "../footer.module.scss";
import { EditModeButtons } from "./parts/edit_mode_buttons";

export const StandardFooter = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.footer" });
  const { isNew, isDraft, isEdit } = useActivityFormStore((state) => state.activityStatus);
  const [createAsDraft, setCreateAsDraft] = useState(isDraft);

  const onSubmit = useActivityFormSubmit();

  return (
    <>
      <Inline as="span" gap="spacingLg">
        {isNew && (
          <>
            <Checkbox label={t("createAsDraft")} checked={createAsDraft} onChange={setCreateAsDraft} />
            <Button
              kind="primary"
              text={t("create")}
              onClick={() => onSubmit({ draft: createAsDraft })}
              className={css.footerButton}
            />
          </>
        )}
        {isEdit && <EditModeButtons />}
      </Inline>
    </>
  );
};
